/** Animate the step timeline as it scrolls, without trapping scrolling. */
export default {
    init() {
        document.querySelectorAll('[data-step-timeline]').forEach((root) => {
            if (root.dataset.processReady) return;
            const path = root.querySelector('[data-process-path]');
            const dot = root.querySelector('[data-process-dot]');
            const steps = [...root.querySelectorAll('[data-process-step]')];
            if (!path || !dot || !steps.length) return;
            const length = path.getTotalLength();
            const reduced = window.matchMedia(
                '(prefers-reduced-motion: reduce)'
            );
            let frame = 0;
            path.style.strokeDasharray = `${length} ${length}`;
            const update = () => {
                frame = 0;
                const rect = root.getBoundingClientRect();
                // Source timing: start at top 35%, finish at bottom 75%.
                const distance = Math.max(
                    1,
                    rect.height - window.innerHeight * 0.4
                );
                const progress = reduced.matches
                    ? 1
                    : Math.max(
                          0,
                          Math.min(
                              1,
                              (window.innerHeight * 0.35 - rect.top) / distance
                          )
                      );
                path.style.strokeDashoffset = -length * (1 - progress);
                const point = path.getPointAtLength(length * (1 - progress));
                dot.setAttribute('cx', point.x);
                dot.setAttribute('cy', point.y);
                root.style.setProperty('--process-progress', progress);
                steps.forEach((step, index) => {
                    step.classList.toggle(
                        'is-active',
                        progress + 0.16 >= (index + 1) / steps.length
                    );
                });
            };
            const schedule = () => {
                if (!frame) frame = requestAnimationFrame(update);
            };
            root.dataset.processReady = 'true';
            update();
            window.addEventListener('scroll', schedule, { passive: true });
            window.addEventListener('resize', schedule);
            reduced.addEventListener('change', schedule);
            new ResizeObserver(schedule).observe(root);
        });
    }
};
